const BASE_URL = process.env.REACT_APP_API_URL;

export const UPDATE_ROLE_NAME = (id, baseUrl = false) =>
  baseUrl ? BASE_URL + `/job/${id}/role-name` : `/job/${id}/role-name`;

// Job
export const JOB = BASE_URL + "/jobs";
export const JOBS = (companyId) => `${BASE_URL}/companies/${companyId}/jobs`;
export const JOB_DESCRIPTION = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/description";
export const UPDATE_INTERVIEW_QUESTIONS = (companyId, jobId) =>
  BASE_URL +
  "/companies/" +
  companyId +
  "/jobs/" +
  jobId +
  "/interview-questions";
export const UPDATE_ROLE_DETAILS = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/role-details";
export const UPDATE_HIRING_PREFERENCES = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/hiring-preferences";
export const REGENERATE_INTERVIEW_QUESTIONS = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/regenerate`;
export const GENERATE_SCORING_RUBRIC = (companyId, jobId, questionId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/questions/${questionId}/generate-scoring-rubric`;
export const REPLACE_SNAPSHOT_DESIRED_RESPONSES = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/dev/replace-snapshot-desired-responses`;
export const REGENERATE_SCORING_RUBRICS = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/dev/regenerate-scoring-rubrics`;
export const SETUP_JOB = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/setup`;
export const COMPLETE_JOB_SETUP_MANUALLY = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/setup/complete-manually`;
export const ANALYSIS_CRITERIA = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/analysis-criteria`;
export const ANALYSIS_RULES = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/analysis-rules`;
export const GENERATE_ANALYSIS_CRITERIA = (companyId, jobId) =>
  `${ANALYSIS_CRITERIA(companyId, jobId)}/generate`;
export const JOB_DOCUMENTS = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/documents`;
export const JOB_DOCUMENT = (companyId, jobId, documentId) =>
  `${JOB_DOCUMENTS(companyId, jobId)}/${documentId}`;

export const RETRY_ANALYSIS = (companyId, jobId, sessionId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/interviews/${sessionId}/retry-analysis`;
export const BULK_RETRY_ANALYSIS = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/interviews/retry-analysis`;
export const RESOLVE_SHORT_URL = (shortId) => BASE_URL + `/i/${shortId}`;
export const DEV_SEND_INTERVIEW_MESSAGE = BASE_URL + "/dev/send-interview-message";

// Candidate
export const SEND_INTERVIEWS = (companyId, jobId) =>
  BASE_URL +
  "/companies/" +
  companyId +
  "/jobs/" +
  jobId +
  "/candidates/invite";
export const RESEND_INTERVIEW = (companyId, jobId, candidateId) =>
  BASE_URL +
  "/companies/" +
  companyId +
  "/jobs/" +
  jobId +
  "/candidates/" +
  candidateId +
  "/resend-interview";
export const SEND_CALENDAR_LINK = (companyId, jobId) =>
  BASE_URL +
  "/companies/" +
  companyId +
  "/jobs/" +
  jobId +
  "/candidates/calendar-link";
export const SEND_CALENDAR_REMINDER = (companyId, jobId) =>
  BASE_URL +
  "/companies/" +
  companyId +
  "/jobs/" +
  jobId +
  "/candidates/calendar-reminder";
export const SEND_SINGLE_INTERVIEW = BASE_URL + "/interview/invite-me";
export const FETCH_CANDIDATE_STATUS = BASE_URL + "/api/candidate-status";
export const DELETE_CANDIDATE_CONTACT = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/candidates";
export const GET_CANDIDATE_CONTACT_STATUS = BASE_URL + "/candidates";
export const UPLOAD_CANDIDATE_TO_JOB = (companyId, jobId) =>
  BASE_URL +
  "/companies/" +
  companyId +
  "/jobs/" +
  jobId +
  "/candidates/upload";
export const FETCH_CANDIDATE_INTERVIEWS = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/candidates";
export const UPDATE_INTERVIEW_ANALYSIS_FEEDBACK = (
  companyId,
  jobId,
  interviewSessionId
) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/interviews/${interviewSessionId}/analysis-feedback`;
export const GET_CANDIDATE_RESUME = (companyId, jobId, candidateId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/candidates/${candidateId}/resume`;
export const GET_CANDIDATE_RESUME_PDF = (companyId, jobId, candidateId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/candidates/${candidateId}/resume/pdf`;
export const GENERATE_CANDIDATE_RESUME_INSIGHTS = (companyId, jobId, candidateId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/candidates/${candidateId}/resume/insights`;
export const GET_CANDIDATE_TRANSCRIPT = (
  companyId,
  jobId,
  candidateId,
  sessionId
) => {
  const url = `${BASE_URL}/companies/${companyId}/jobs/${jobId}/candidates/${candidateId}/transcript`;
  if (!sessionId) {
    return url;
  }
  return `${url}?session_id=${encodeURIComponent(sessionId)}`;
};

export const CLOSE_INTERVIEW = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/interviews/close";
export const REOPEN_INTERVIEW = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/interviews/reopen";

// User
export const USER = BASE_URL + "/register";
export const COMPANY = BASE_URL + "/company";
export const COMPANY_MEMBERS = BASE_URL + "/company/users";
export const ROLES = BASE_URL + "/roles";
export const ME = BASE_URL + "/me";
export const ATS_INTEGRATION = (companyId) =>
  `${BASE_URL}/ats/${companyId}/jobs`;
export const FETCH_COMPANY_NAME = (companyId) =>
  `${BASE_URL}/company/${companyId}/name`;
export const FETCH_JOB_COMPANY_NAME = (jobId) =>
  `${BASE_URL}/jobs/${jobId}/company-name`;
export const FETCH_JOB_NAME = (jobId) =>
  `${BASE_URL}/jobs/${jobId}/name`;
export const DELETE_JOB = (companyId, jobId) =>
  `${BASE_URL}/company/${companyId}/jobs/${jobId}`;
export const DUPLICATE_JOB = (companyId, jobId) =>
  `${BASE_URL}/company/${companyId}/jobs/${jobId}/duplicate`;
export const FETCH_USERS_BY_COMPANY_ID = (companyId) =>
  `${BASE_URL}/company/users?company_id=${companyId}`;
export const REMOVE_USER_FROM_COMPANY = (userId, companyId) =>
  `${BASE_URL}/user/remove-from-company?user_id=${userId}&company_id=${companyId}`;
export const DELETE_USER = (userId) =>
  `${BASE_URL}/user/delete?user_id=${userId}`;
export const SET_SUPERUSER_STATUS = (userId, isSuperuser) =>
  `${BASE_URL}/user/superuser?user_id=${userId}&is_superuser=${isSuperuser}`;
export const UPDATE_COMPANY_NAME = (companyId, companyName) =>
  `${BASE_URL}/user/company/name?company_id=${companyId}&company_name=${companyName}`;
export const UPDATE_COMPANY_DOMAIN = (companyId, companyDomain) =>
  `${BASE_URL}/user/company/domain?company_id=${companyId}&company_domain=${companyDomain}`;
export const UPDATE_COMPANY_DEFAULT_INTERVIEW_TYPES = (companyId) =>
  `${BASE_URL}/user/company/${companyId}/default-interview-types`;
export const UPDATE_ATS_INTEGRATION_ID = (companyId, atsIntegrationId) =>
  `${BASE_URL}/user/company/ats-integration?company_id=${companyId}&ats_integration_id=${atsIntegrationId}`;
export const UPDATE_USER_NAME = (userId, newName) =>
  `${BASE_URL}/user/name?user_id=${userId}&new_name=${newName}`;

// Company
export const INVITE_USER = (companyId) =>
  BASE_URL + "/company/" + companyId + "/invite";
export const INVITE_VERIFY = BASE_URL + "/invite/";
export const INVITE_ACCEPT = (token) =>
  BASE_URL + "/invite/" + token + "/accept";
export const UPDATE_PERMISSION = (user_id) =>
  BASE_URL + "/user/" + user_id + "/role";
export const INVITE_PENDING = BASE_URL + "/invite";
export const INVITE_ROLE_UPDATE = (token) =>
  BASE_URL + "/invite/" + token + "/role";

export const INVITE_BY_LINK = (companyId) =>
  BASE_URL + "/company/" + companyId + "/invite/link";

export const DELETE_INVITE = BASE_URL + "/invite/";

export const SAVE_INTRO_MESSAGE = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/intro-message";
export const SAVE_OUTRO_MESSAGE = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/outro-message";
export const SAVE_CALENDAR_MESSAGE = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/calendar-message";
export const SAVE_CALENDAR_REMINDER_MESSAGE = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/calendar-reminder-message";
export const GET_JOB_MESSAGES = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/messages";

export const SAVE_CALENDAR_SETTINGS = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/calendar-settings";
export const GET_CALENDAR_SETTINGS = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/calendar-settings";
export const UPDATE_AUTOMATIC_SCHEDULING = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/automatic-scheduling";
export const UPDATE_AUTOMATIC_INTERVIEWS = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/automatic-interviews";
export const GET_JOB_ATS_STAGES = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/ats-stages";
export const UPDATE_JOB_STAGE_SETTINGS = (companyId, jobId) =>
  BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/stage-settings";
export const UPDATE_NOTIFICATION_SETTINGS = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/notification-settings";
export const GET_NOTIFICATION_SETTINGS = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/notification-settings";
export const UPDATE_JOB_INTERVIEW_TYPES = (companyId, jobId) => BASE_URL + "/companies/" + companyId + "/jobs/" + jobId + "/interview-types";

// Shortlist digest
export const DIGEST_SETTINGS = BASE_URL + "/users/me/digest-settings";
export const DIGEST_ROLES = BASE_URL + "/users/me/digest-roles";
export const DIGEST_ROLE = (jobId) => BASE_URL + `/users/me/digest-roles/${jobId}`;
export const DIGEST_ROLES_BULK = BASE_URL + "/users/me/digest-roles/bulk";
export const DIGEST_TEST = BASE_URL + "/users/me/digest/test";
export const DIGEST_OVERVIEW = (jobId) =>
  `${BASE_URL}/users/me/digest/overview?job_id=${encodeURIComponent(jobId)}`;
export const DIGEST_PREVIEW = (jobId, scenario) => {
  const params = new URLSearchParams({ job_id: jobId });
  if (scenario) params.set("scenario", scenario);
  return `${BASE_URL}/users/me/digest/preview?${params.toString()}`;
};
export const COMPANY_DIGEST_SETTINGS = (companyId) =>
  BASE_URL + `/companies/${companyId}/digest-settings`;

export const CLOSE_JOB = (companyId, jobId) => BASE_URL + `/company/${companyId}/jobs/${jobId}/close`;
export const OPEN_JOB = (companyId, jobId) => BASE_URL + `/company/${companyId}/jobs/${jobId}/open`;

// Reject Candidates
export const REJECTION_REASONS = (companyId) =>
  `${BASE_URL}/ats/${companyId}/rejection-reasons`;
export const REJECT_CANDIDATES = (companyId, jobId) =>
  `${BASE_URL}/companies/${companyId}/jobs/${jobId}/candidates/reject`;

// Candidate Search
export const SEARCH_CANDIDATES = (companyId) => BASE_URL + `/companies/${companyId}/candidates/search`;
